module.exports = __webpack_public_path__ + "static/semiperm1-ae0b1095fd107d9633514139d2f547ce.jpg";